var map = {
	"./decidim/avatar-multiuser.png": 2677,
	"./decidim/brands/facebook.svg": 89713,
	"./decidim/brands/google.svg": 43560,
	"./decidim/brands/twitter-x.svg": 97389,
	"./decidim/cc-badge.png": 45747,
	"./decidim/decidim-logo.svg": 84695,
	"./decidim/default-avatar.svg": 24763,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 90673,
	"./decidim/icons.svg": 11018,
	"./decidim/pattern.png": 39897,
	"./decidim/placeholder-card-g.svg": 90614,
	"./decidim/placeholder-card-l.svg": 93277,
	"./decidim/placeholder.jpg": 18140,
	"./decidim/remixicon.symbol.svg": 28558,
	"./decidim/vendor/social-share-button/douban.svg": 56689,
	"./decidim/vendor/social-share-button/email.svg": 85330,
	"./decidim/vendor/social-share-button/facebook.svg": 50810,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 95286,
	"./decidim/vendor/social-share-button/hacker_news.svg": 60066,
	"./decidim/vendor/social-share-button/linkedin.svg": 5376,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 31801,
	"./decidim/vendor/social-share-button/pinterest.svg": 85580,
	"./decidim/vendor/social-share-button/reddit.svg": 77254,
	"./decidim/vendor/social-share-button/telegram.svg": 18263,
	"./decidim/vendor/social-share-button/tumblr.svg": 71412,
	"./decidim/vendor/social-share-button/twitter.svg": 83879,
	"./decidim/vendor/social-share-button/vkontakte.svg": 83701,
	"./decidim/vendor/social-share-button/wechat.svg": 59704,
	"./decidim/vendor/social-share-button/whatsapp.svg": 26200,
	"./decidim/vendor/social-share-button/x.svg": 22258,
	"./decidim/vendor/social-share-button/xing.svg": 1238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32608;